import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getdata, getdatanoauth, updatedata } from "../../util/global";
import { product, productdef } from './Datatype';
import ShopTable from './ShopTable';
// import ShopCartModal from './ShopCartModal';
import ProductView from './ProductView';

interface cartitem {
  productid: string;
  name: string;
  price: number | string;
  quantity: number;
}

const Shop = () => {
  const navigate = useNavigate();
  const [products, setproducts] = useState<product[]>([]);
  const [files, setfiles] = useState<any[]>([]);
  const [cartitems, setcartitems] = useState<cartitem[]>([]);
  const [selectedproduct, setselectedproduct] = useState<product>(productdef);
  const [showmodal, setshowmodal] = useState("");
  const [cartid, setcartid] = useState<string | null>(null);

  const fetchproducts = async () => {
    const res = await getdatanoauth({ filter: { datatype: "productdata" } });
    setproducts(res.filter((p: product) => p.status === 'active').reverse());

    const filedata = await getdatanoauth({ filter: { datatype: "filedata", filetype: "productfile", dbcollection: "appfiledata" } });
    setfiles(filedata);
  };

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const opencart = async () => {
    let cartjson = localStorage.getItem("cart");
    if (window.APPUSER && window.APPUSER.user) {
      const dbcart = await getdata({ filter: { datatype: "cartdata", userid: window.APPUSER.user.userid } });
      if (dbcart.length > 0) {
        setcartid(dbcart[0]._id);
        localStorage.setItem("cart", JSON.stringify(dbcart[0].items));
        setcartitems(dbcart[0].items);
      } else {
        setcartitems(JSON.parse(cartjson || "[]"));
      }
    } else {
      setcartitems(JSON.parse(cartjson || "[]"));
    }
    setshowmodal("showcartmodal");
  };

  const fetchcart = async () => {
    let cartjson = localStorage.getItem("cart");
    if (window.APPUSER && window.APPUSER.user) {
      const dbcart = await getdata({ filter: { datatype: "cartdata", userid: window.APPUSER.user.userid } });
      if (dbcart.length > 0) {
        setcartid(dbcart[0]._id);
        localStorage.setItem("cart", JSON.stringify(dbcart[0].items));
        setcartitems(dbcart[0].items);
      } else {
        setcartitems(JSON.parse(cartjson || "[]"));
      }
    } else {
      setcartitems(JSON.parse(cartjson || "[]"));
    }
  };

  const synccart = async (cart: cartitem[]) => {
    if (!(window.APPUSER && window.APPUSER.user)) return;
    let id = cartid;
    if (!id) {
      const existing = await getdata({ filter: { datatype: "cartdata", userid: window.APPUSER.user.userid } });
      if (existing.length > 0) { id = existing[0]._id; setcartid(id); }
    }
    const data: any = { datatype: "cartdata", userid: window.APPUSER.user.userid, items: cart };
    if (id) data._id = id;
    await updatedata({ data });
  };

  const openview = (item: product) => {
    setselectedproduct(item);
    setshowmodal("showproductview");
  };

  const addtocart = (item: product) => {
    const cart: cartitem[] = JSON.parse(localStorage.getItem("cart") || "[]");
    const existing = cart.find((c) => c.productid === item._id);

    if (existing) {
      existing.quantity += 1;
    } else {
      cart.push({
        productid: item._id,
        name: item.name,
        price: item.price,
        quantity: 1
      });
    }

    localStorage.setItem("cart", JSON.stringify(cart));
    setcartitems(cart);
    synccart(cart);
    // setshowmodal("showcartmodal");
  };

  const updatequantity = (productid: string, delta: number) => {
    const updated = cartitems
      .map((item) => {
        if (item.productid === productid) {
          return { ...item, quantity: item.quantity + delta };
        }
        return item;
      })
      .filter((item) => item.quantity > 0);

    localStorage.setItem("cart", JSON.stringify(updated));
    setcartitems(updated);
    synccart(updated);
  };

  const removefromcart = (productid: string) => {
    const updated = cartitems.filter((item) => item.productid !== productid);
    localStorage.setItem("cart", JSON.stringify(updated));
    setcartitems(updated);
    synccart(updated);
  };

  useEffect(() => {
    fetchproducts();
    fetchcart();

    // const handleopencart = () => opencart();
    // window.addEventListener('opencart', handleopencart);
    // return () => window.removeEventListener('opencart', handleopencart);
  }, []);

  const carttotal = cartitems.reduce((sum, item) => sum + (Number(item.price) || 0) * item.quantity, 0);

  return (
    <div className="content-area" style={{ padding: '24px', paddingBottom: '90px', maxWidth: '1200px', margin: '0 auto' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <h2>Product Catalog</h2>
        {/* <button type="button" className="btn-blue" onClick={opencart}>
          My Subscription
        </button> */}
      </div>

      <ShopTable 
        products={products} 
        files={files} 
        addtocart={addtocart} 
        openview={openview}
        cartitems={cartitems}
        updatequantity={updatequantity}
        removefromcart={removefromcart}
      />

      {/* <ShopCartModal 
        showmodal={showmodal} 
        setshowmodal={setshowmodal} 
        cartitems={cartitems} 
        updatequantity={updatequantity} 
        removefromcart={removefromcart} 
      /> */}

      <ProductView 
        showmodal={showmodal} 
        setshowmodal={setshowmodal} 
        productdata={selectedproduct} 
        files={files} 
      />

      {cartitems.length > 0 && (
        <div className="cartbar">
          <div className="cartbar-info">
            {cartitems.length} product{cartitems.length > 1 ? 's' : ''} <span>· ₹{carttotal} per delivery</span>
          </div>
          <button type="button" className="btn-blue" onClick={() => window.APPUSER && window.APPUSER.user ? navigate('/subscribe') : navigate('/login')}>
            Next →
          </button>
        </div>
      )}
    </div>
  );
};

export default Shop;